// dependencies
import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";

// selectors
import { getCurrentEnvironmentName } from "Selectors/app";

export const BranchCheck = CreateProcess({
	method: "GET",
	name: "BranchCheck",
	type: "APP:BRANCHCHECK",

	request: () => ({
		url: "/branches/",
	}),

	success: (response) => fromJS(response.data),
});

export const MeanResponseTime = CreateProcess({
	method: "GET",
	name: "MeanResponseTime",
	type: "APP:MeanResponseTime",

	request: (props, { getState }) => {
		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		return {
			url: `/${environment}/total-mean-response-time/`,
		};
	},

	success: (response) => response.data.meanResponseTime,
	error: () => 0,
});

export const OneDayTotalRequestsCount = CreateProcess({
	method: "GET",
	name: "OneDayTotalRequestsCount",
	type: "APP:OneDayTotalRequestsCount",

	request: (props, { getState }) => {
		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		return {
			url: `/${environment}/total-request-count/`,
		};
	},

	success: (response) => response.data.totalRequestCount,
});

export const TotalCompanyCount = CreateProcess({
	method: "GET",
	name: "TotalCompanyCount",
	type: "APP:COMPANY.COUNT",

	request: (props, { getState }) => {
		const state = getState();
		const environment = getCurrentEnvironmentName(state);

		return {
			url: `/${environment}/total-company-count/`,
		};
	},

	success: (response) => response.data,
});
